// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1ouCw","title":"InfoRow_title__3bcGa"};